export default "__VITE_ASSET__Du9ZW3dS__"